import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-loginpanel',
    templateUrl: './loginpanel.component.html',
    styleUrls: ['./loginpanel.component.css']
})
export class LoginpanelComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
